import axios from "axios";

class DataService {
    constructor() {
        this.dataAPI = 'assets/js/json/PPI Data.json'; // API URL
        this.descriptionAPI = 'assets/js/json/region_description.json';
        this.token = ''; // Add your token here or dynamically set it
        this.data = null; // Placeholder for fetched data
        this.dataDescription
    }

    async fetchData() {
        if (this.data) {
            // Return cached data if already fetched
            return this.data;
        }

        try {
            const response = await axios.get(this.dataAPI, {
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            });
            this.data = response.data; // Cache the fetched data
            return this.data;
        } catch (error) {
            console.error('Error fetching data:', error.response?.data || error.message);
            throw error; // Propagate error for further handling
        }
    }

    async fetchDescription(){
        if (this.dataDescription) {
            // Return cached data if already fetched
            return this.dataDescription;
        }

        try {
            const response = await axios.get(this.descriptionAPI, {
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            });
            this.dataDescription = response.data; // Cache the fetched data
            return this.dataDescription;
        } catch (error) {
            console.error('Error fetching data:', error.response?.data || error.message);
            throw error; // Propagate error for further handling
        }
    }
}

// Export a singleton instance of the service
export default new DataService();
